module.exports = __webpack_public_path__ + "img/water-droplet-1.655be580.png";